var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1283"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1283"
    },
    "bundlingPackage": "academy-achievements-public-ui",
    "bundlingPackageVersion": "static-1.1116",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};